import { PAYMENT_METHOD_OPTIONS, paymentMethodLabel } from '../../../utils/splitPaymentUtils';

function rowsForAllMethods(splits) {
  return PAYMENT_METHOD_OPTIONS.map((m) => {
    const found = (splits || []).find((s) => s.method === m.key);
    return { method: m.key, amount: found?.amount ?? '' };
  });
}

export default function SplitPaymentFields({
  idPrefix,
  splits,
  onChange,
  disabled = false,
}) {
  const rows = rowsForAllMethods(splits);

  const updateAmount = (method, value) => {
    const next = PAYMENT_METHOD_OPTIONS.map((m) => {
      if (m.key === method) return { method: m.key, amount: value };
      const found = (splits || []).find((s) => s.method === m.key);
      return { method: m.key, amount: found?.amount ?? '' };
    });
    onChange(next);
  };

  return (
    <div className="rec-split-payment">
      <span className="owner-form-label">Payment methods & amounts</span>
      <div className="rec-split-payment-rows rec-split-payment-rows-all">
        {rows.map((row) => (
          <div key={row.method} className="rec-split-payment-row rec-split-payment-row-fixed">
            <label
              className="rec-split-payment-method-label"
              htmlFor={`${idPrefix}-split-amount-${row.method}`}
            >
              {paymentMethodLabel(row.method)}
            </label>
            <input
              id={`${idPrefix}-split-amount-${row.method}`}
              type="text"
              inputMode="decimal"
              className="owner-form-input"
              value={row.amount === '' || row.amount == null ? '' : String(row.amount)}
              onChange={(e) => updateAmount(row.method, e.target.value)}
              placeholder="Amount"
              disabled={disabled}
              aria-label={`${paymentMethodLabel(row.method)} amount`}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
